import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Skeleton from "@mui/material/Skeleton";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { ConfigProvider, theme as antdTheme } from "antd";
// Data
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useAxiosPrivate } from "hooks/useAxiosPrivate";
import { useEffect, useState } from "react";
const { RangePicker } = DatePicker;
import callReportTableData from "layouts/tables/callReportTableData";
import authorsTableData from "layouts/tables/data/authorsTableData";
import projectsTableData from "layouts/tables/data/projectsTableData";
import { useMaterialUIController } from "context";
function Tables() {
  // const { columns, rows } = authorsTableData();
  const { columns: pColumns, rows: pRows } = projectsTableData();
  const axiosPrivate = useAxiosPrivate();
  const [dates, setDates] = useState([dayjs(), dayjs()]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiParams, setApiParams] = useState({
    callType: "Max Calls",
    startTime: dayjs().startOf("day").unix(),
    endTime: dayjs().endOf("day").unix(),
  });

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const mapCallReportToTable = (apiData = []) => {
    return apiData.map((item) => ({
      author: item?.callBy?.name || "",
      function: item?.reportsTo?.name || "",
      status: item?.callSummary?.connectedCall ?? 0,
      employed: item?.callSummary?.avg || "",
      action: item?.callSummary?.totalAssignedCount ?? 0,
      dialed: item?.callSummary?.completedCall ?? 0,
    }));
  };

  // const { columns, rows } = callReportTableData(data);
  const { columns, rows } = callReportTableData(data);
  const getData = (params) => {
    setLoading(true);
    let urlParams = "";
    if (params) {
      Object.keys(params).forEach(function (key, index) {
        urlParams += (index === 0 ? "?" : "&") + key + "=" + params[key];
      });
    }
    let url = `om/get-call-report${urlParams}`;
    let options = {
      method: "GET",
      url,
    };
    axiosPrivate(options)
      .then((response) => {
        // console.log(response?.data?.data?.reports);
        const dataMapped = mapCallReportToTable(response?.data?.data?.reports);
        // console.log(dataMapped);
        // setData(dataMapped);
        setLoading(false);
        setData(response?.data?.data?.reports);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    const prm = apiParams;
    getData(prm);
  }, []);

  const columnsTab = [
    { Header: "Caller", accessor: "author", align: "left" },
    { Header: "Reports To", accessor: "function", align: "left" },
    { Header: "Connected Calls", accessor: "status", align: "center" },
    { Header: "Dialed Calls", accessor: "dialed", align: "center" },
    { Header: "Avg Call Duration", accessor: "employed", align: "center" },
    { Header: "Assigned Calls", accessor: "action", align: "center" },
  ];

  const handleChange = (params) => {
    // console.log(params);
    if (!params) return;
    // console.log(params);
    setDates(params);
    const startEpoch = params[0].startOf("day").unix();
    const endEpoch = params[1].endOf("day").unix();
    getData({
      startTime: startEpoch,
      endTime: endEpoch,
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={0}>
        <MDBox
          mt={0}
          mb={4}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          sx={{
            gap: 2,
          }}
        >
          {/* LEFT SIDE */}
          <MDBox fontWeight="bold" sx={{ fontSize: 18 }}></MDBox>

          {/* RIGHT SIDE: BOTH SELECT + DATE */}
          <MDBox
            display="flex"
            alignItems="center"
            gap={2}
            flexWrap="wrap"
            sx={{
              justifyContent: { xs: "flex-start", md: "flex-end" },
              width: { xs: "100%", md: "auto" }, // full width on mobile
            }}
          >
            {/* <MDBox
              sx={{
                minWidth: { xs: "100%", sm: 220, md: 260 },
              }}
            >
              <RangePicker
                value={dates}
                onChange={handleChange}
                style={{ minWidth: 250 }}
                allowClear={false}
              />
            </MDBox> */}
            <MDBox
              sx={{
                minWidth: { xs: "100%", sm: 220, md: 260 },
              }}
            >
              <ConfigProvider
                theme={{
                  algorithm: darkMode ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
                  components: {
                    DatePicker: {
                      colorBgContainer: darkMode ? "#1a2035" : "#fff",
                      colorText: darkMode ? "#fff" : "#000",
                      colorBorder: darkMode ? "#475894" : "#d9d9d9",
                      colorBgElevated: darkMode ? "#1f2937" : "#fff",
                      colorPrimary: darkMode ? "#1890ff" : "#1890ff",
                    },
                  },
                }}
              >
                <RangePicker
                  value={dates}
                  onChange={handleChange}
                  style={{ minWidth: 250 }}
                  allowClear={false}
                />
              </ConfigProvider>
            </MDBox>
          </MDBox>
        </MDBox>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Call Report
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  // table={{ columns: columnsTab, rows: data }}
                  table={{ columns, rows }}
                  // table={{ columns: pColumns, rows: pRows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                  loading={loading}
                />
              </MDBox>
            </Card>
          </Grid>
          {/* <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Projects Table
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: pColumns, rows: pRows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid> */}
        </Grid>

        {/* <MDBox mt={8}>
          <ReportsBarChart
            color="info"
            title="Total Calls View"
            description="Last Calling Performance"
            // date=""
            chart={reportsBarChartData}
          />
        </MDBox> */}
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Tables;
